var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"side-panel"}},[_c('b-avatar',{staticClass:"avatar-with-border",attrs:{"src":require('../static/scholar.jpg'),"size":"10em"}}),_c('p',{attrs:{"id":"name"}},[_vm._v("Giorgia Nadizar")]),_c('p',{attrs:{"id":"tagline"}},[_vm._v("PostDoctoral Research Fellow in Interpretable Control")]),_c('SocialIcons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }